package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.BusinessCenterW500Rounded: ImageVector
    get() {
        if (_businessCenterW500Rounded != null) {
            return _businessCenterW500Rounded!!
        }
        _businessCenterW500Rounded = Builder(name = "BusinessCenterW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(162.87f, 848.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                lineTo(71.87f, 326.7f)
                quadToRelative(0.0f, -37.79f, 26.61f, -64.4f)
                quadToRelative(26.61f, -26.6f, 64.39f, -26.6f)
                horizontalLineToRelative(149.72f)
                verticalLineToRelative(-80.0f)
                quadToRelative(0.0f, -37.79f, 26.61f, -64.4f)
                quadToRelative(26.6f, -26.6f, 64.39f, -26.6f)
                horizontalLineToRelative(152.82f)
                quadToRelative(37.79f, 0.0f, 64.39f, 26.6f)
                quadToRelative(26.61f, 26.61f, 26.61f, 64.4f)
                verticalLineToRelative(80.0f)
                horizontalLineToRelative(149.72f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.6f)
                quadToRelative(26.61f, 26.61f, 26.61f, 64.4f)
                verticalLineToRelative(430.43f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(162.87f, 848.13f)
                close()
                moveTo(403.59f, 235.7f)
                horizontalLineToRelative(152.82f)
                verticalLineToRelative(-80.0f)
                lineTo(403.59f, 155.7f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(797.13f, 597.13f)
                lineTo(600.0f, 597.13f)
                verticalLineToRelative(34.5f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.33f)
                quadToRelative(-13.18f, 13.17f, -32.33f, 13.17f)
                horizontalLineToRelative(-149.0f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadTo(360.0f, 650.78f, 360.0f, 631.63f)
                verticalLineToRelative(-34.5f)
                lineTo(162.87f, 597.13f)
                verticalLineToRelative(160.0f)
                horizontalLineToRelative(634.26f)
                verticalLineToRelative(-160.0f)
                close()
                moveTo(440.0f, 597.13f)
                horizontalLineToRelative(80.0f)
                verticalLineToRelative(-80.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(80.0f)
                close()
                moveTo(162.87f, 517.13f)
                lineTo(360.0f, 517.13f)
                verticalLineToRelative(-34.5f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(149.0f)
                quadToRelative(19.15f, 0.0f, 32.33f, 13.17f)
                quadTo(600.0f, 463.48f, 600.0f, 482.63f)
                verticalLineToRelative(34.5f)
                horizontalLineToRelative(197.13f)
                lineTo(797.13f, 326.7f)
                lineTo(162.87f, 326.7f)
                verticalLineToRelative(190.43f)
                close()
                moveTo(480.0f, 557.13f)
                close()
            }
        }
        .build()
        return _businessCenterW500Rounded!!
    }

private var _businessCenterW500Rounded: ImageVector? = null
